import { useEffect } from 'react';

import { useErrorBoundary } from 'react-error-boundary';

import type { AxiosError } from 'axios';

import type { CommonResponse } from '@shared/index';
import { BoundaryErrorType, FlkCode, getMismatches } from '@shared/index';

interface UseHandleOtpRefreshCodeErrors {
  error: AxiosError<CommonResponse> | null;
  resetQueryErrorRefreshCode: () => void;
}

export const useHandleOtpRefreshCodeErrors = ({
  error,
  resetQueryErrorRefreshCode,
}: UseHandleOtpRefreshCodeErrors) => {
  const { showBoundary } = useErrorBoundary();

  useEffect(() => {
    if (error) {
      const mismatches = getMismatches(error);
      if (!!mismatches) {
        let hasKnownErrors = false;
        mismatches.forEach(({ code }) => {
          if (code === FlkCode.OTP_0101_0004) {
            hasKnownErrors = true;
          }
        });
        if (hasKnownErrors) {
          return;
        }
      }
      resetQueryErrorRefreshCode();
      showBoundary(BoundaryErrorType.SomethingWentWrong);
    }
  }, [error, resetQueryErrorRefreshCode]);
};
